import { Link } from "react-router-dom";
import { useState, useEffect, useCallback } from "react";
import { auth } from "../services/auth";
import { getPosts } from "../services/blog";
import Pagination from "../pagination/pagination";
import Loader from "../shared/Loader";
import { Helmet } from "react-helmet";
import BlogCard from "../components/BlogCard";
import styles from "../css/blog.module.css";

export default function Blog() {
  const [posts, setPosts] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [hasError, setHasError] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [isAdmin, setIsAdmin] = useState(false);
  const [config, setConfig] = useState(null);
  const [pageSize, setPageSize] = useState(12);

  useEffect(() => {
    setConfig({
      headers: { Authorization: `Bearer ${auth().getToken()}` },
    });
    setIsAdmin(auth().isAdmin());
    setPageSize(12);
  }, []);

  const fetchPosts = useCallback(() => {
    if (config) {
      setIsLoading(true);
      getPosts(
        {
          currentPage: currentPage,
          pageSize: pageSize,
        },
        config
      )
        .then((response) => {
          setHasError(false);
          setPosts(response.data.data);
          setTotalRecords(response.data.totalRecords);
        })
        .catch((error) => {
          setHasError(true);
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  }, [currentPage, pageSize, config]);

  useEffect(() => {
    fetchPosts();
  }, [fetchPosts]);

  const handleDelete = (id) => {
    setPosts(posts.filter((post) => post.id !== id));
  };

  return (
    <section className="flex flex-col my-12">
      <Helmet>
        <title>Dailysocialboost | Blog</title>
      </Helmet>
      <div className="flex items-center">
        <h2 className="text-5xl font-bold my-8 mx-auto">Blog</h2>
      </div>
      {isAdmin ? (
        <div className="flex flex-row justify-start my-3">
          <Link to="/blog/add" className={styles.addPostBtn}>
            Add post
          </Link>
        </div>
      ) : null}
      {isLoading ? (
        <div className="flex flex-row self-center">
          <Loader styles={"w-20 h-20 self-center"}></Loader>{" "}
        </div>
      ) : hasError ? (
        <p className="text-3xl font-bold text-red-600 text-center">Failed fetching posts!</p>
      ) : !posts.length ? (
        <p className="text-3xl font-bold text-red-600 text-center">Posts were not found!</p>
      ) : null}
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-2 lg:gap-5">
        {posts.length
          ? posts.map((post, idx) => (
              <BlogCard
                key={`blog-post-${post.id}`}
                blogKey={`blog-post-${idx}`}
                idx={idx}
                post={post}
                handleDelete={handleDelete}
              />
            ))
          : null}
      </div>
      <div className="mt-16 text-center mx-auto">
        <Pagination
          className="pagination-bar"
          currentPage={currentPage}
          totalCount={totalRecords}
          pageSize={pageSize}
          onPageChange={(page) => setCurrentPage(page)}
        />
      </div>
    </section>
  );
}
